import styled, { css } from 'styled-components';

import { primitive } from '../../designTokens/primitives';
import { mediaQuery } from '../../globalStyles';
import { buttonAsLinkReset } from '../../utils/styles';
import { Grid } from '../grid';

export const HeroGrid = styled(Grid)<{ $reversed: boolean }>`
  row-gap: ${primitive.$spacing3};
  align-items: center;

  margin-top: ${primitive.$spacing4};
  margin-bottom: ${primitive.$spacing4};
  color: ${(p) =>
    p.$reversed ? p.theme.token('text-hero-reversed') : p.theme.token('text-hero-light')};

  @media ${mediaQuery.desktopLarge} {
    margin-top: ${primitive.$spacing8};
    margin-bottom: ${primitive.$spacing8};
  }
`;

export const ImageWrapper = styled.div`
  overflow: hidden;
  width: 80%;
  height: 240px;
  margin: 0 10%;
  display: flex;
  align-items: center;
  justify-content: center;

  & > * {
    max-width: 100%;
    max-height: 100%;
  }

  @media ${mediaQuery.tablet} {
    margin: 0 6%;
    width: 88%;
    height: 280px;
  }

  @media ${mediaQuery.desktopLarge} {
    height: 440px;
  }
`;

export const HeroHeader = styled.div`
  font: ${(p) => p.theme.token('text-style-hero-header')};
`;

export const HeroSubheader = styled.div`
  margin-top: ${primitive.$spacing3};
  font: ${(p) => p.theme.token('text-style-hero-subheader')};

  @media ${mediaQuery.desktopLarge} {
    margin-top: ${primitive.$spacing6};
  }
`;

export const ButtonsWrapper = styled.div`
  margin-top: ${primitive.$spacing6};

  @media ${mediaQuery.tablet} {
    white-space: nowrap;
  }

  @media ${mediaQuery.desktopLarge} {
    margin-top: ${primitive.$spacing8};
  }
`;

export const TermsWrapper = styled.div<{ $isAbsolute: boolean; $reversed: boolean }>`
  font: ${(p) => p.theme.token('text-style-hero-terms')};
  color: ${(p) =>
    p.$reversed ? p.theme.token('text-hero-reversed') : p.theme.token('text-hero-light')};
  text-align: right;

  ${(p) =>
    p.$isAbsolute &&
    css`
      position: absolute;
      right: ${primitive.$spacing4};
      bottom: ${primitive.$spacing4};
      right: ${primitive.$spacing6};
      bottom: ${primitive.$spacing6};
    `}
`;

export const Terms = styled.button`
  ${buttonAsLinkReset};
  color: inherit;

  &:hover {
    color: ${(p) => p.theme.token('text-link-hover')};
  }
`;
